<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ data.title }}</div>
		</div>

		<div class="item_img"><img :src="data.img" /></div>
		<div class="items_3">
			<div class="item">
				<!-- <div class="item_div1">
					<p>
						{{ data.title }}
					</p>
				</div> -->
				<div class="item_text">
					{{ data["desc_" + lang] }}
				</div>
				<div class="item_div2" v-if="Object.keys(data).length > 0">
					<div class="item_rate divs">
						<img class="logos" src="@/assets/images/mll.png" alt="">
						<div class="my_1">
							<span>{{ data.rate }}%</span>
						</div>
						<div style="font-size: 12px;color: #666;white-space: pre-wrap;word-break: break-all;">
							{{ $t("rgll") }}
						</div>
					</div>
					<div class="item_day divs">
						<img class="logos" src="@/assets/images/time.png" alt="">
						<div class="my_1">
							<span>{{ data.day_date_num_text }}</span>
						</div>
						<div style="font-size: 12px;color: #666;white-space: pre-wrap;word-break: break-all;">
							{{ $t("结算时窗") }}
						</div>
					</div>
					<div class="item_min divs">
						<img class="logos" src="@/assets/images/qd2.png" alt="">
						<div class="my_1">
							<span :style="data.project_type === 1 ? 'font-size:15px;' : 'font-size:15px;'">{{
								data.project_type === 1 ? '$' : $t("utils.moneyMark") }}{{ data.min }}</span>
						</div>
						<div style="font-size: 12px;color: #666;white-space: pre-wrap;word-break: break-all;">
							{{ $t("utils.startingAmount") }}
						</div>
					</div>
				</div>
				<div class="item_div3" v-if="Object.keys(data).length > 0">
					<span>{{ $t("认购次数") }} <b>:</b> <span style="font-size: 14px;color:#333;">{{ data.num }}{{ $t('次') }}</span></span>
				</div>
				<!-- <div class="item_div3" v-if="data.project_type === 1">
					<span>{{ $t("utils.Handling") }}:<span style="font-size: 12px;color:#333;">{{ data.fee_ratio }}%</span></span>
				</div> -->
				<!-- <div class="item_div3" v-if="data.project_type === 1">
					<span>{{ $t("fxbl") }} <b>:</b> <span style="font-size: 14px;color:#333;">{{ data.breach_penalty_rate
					}}%</span></span>
				</div> -->
				<div class="item_div3 m-flex m-f-between">
					<span>{{ $t("票房预估") }} <b>:</b> <span style="font-size: 14px;color:#333;">{{ data.project_type ===
						1 ? '$' : $t("utils.moneyMark") }}</span>
					<span style="font-size: 14px;color:#333;">{{ data.estimated_revenue }}</span>
				</span>
					<!-- <span class="m-f1">{{ $t('utils.scale') }}:<span style="font-size: 12px;color:#333;">{{ data.project_type ===  1?'$':$t('utils.moneyMark') }}{{ data.total }}</span></span> -->
					<!-- <span>   按日收益，到期还本</span> -->
					<!-- <span class="m-f1 text-right" style="margin-top: 0.5em;">{{ {
				0: $t('xi_b'), 1: $t('ben_x')
			}[data.mode]
						}}</span> -->

				</div>
				<div class="item_div4" v-if="data.percent && data.id != 185">
					<div class="flexs">
						<span>{{ $t('认购进度') }}</span>
						<span>{{ data.percent }}%</span>
					</div>
					<van-progress :percentage="data.percent" />
				</div>
				<!-- <div class="item_btn" v-if="data.project_type === 1">
					<button type="button" class="red" @click="buy">NAIK</button>
					<div style="width: 20px;"></div>
					<button type="button" class="green" @click="buy">TURUN</button>
				</div> -->
				<div class="item_btn">
					<button v-if="data.percent < 100" type="button" @click="buy">{{ $t('utils.invest') }}</button>
					<button class="item_btn_over" v-if="data.percent >= 100" type="button">{{ $t('utils.investOver')
					}}</button>
				</div>
			</div>
			<div class="item_content" v-html="data.content"></div>
			<div style="height: 200px;"></div>
			<!-- <div class="table_box" style="padding-bottom: 80px;" v-if="asks.length > 0 && data.project_type === 1 || bids.length > 0 && data.project_type === 1">
				<div class="uls">
					<div class="li" style="background: #eee;">
						<div class="t">
							{{$t('utils.jg')}}
						</div>
						<div class="t">
							{{$t('utils.num')}}
						</div> 
					</div>
					<div class="li_box">
						<div class="li li_red" v-for="item in asks">
							<div class="ts">
								{{ item[0] }}
							</div>
							<div class="ts">
								<span>{{ item[1] }}</span>
							</div>
							<div class="jindu1" :style="{'width':item[3]?item[3]+'%':0+'%'}"></div>
						</div>
					</div>
					
					<div class="li li_t">
						<span class="tt" :class="{'color_red':stockList.last.close < stockList.last.open}">{{stockList.product_price}}</span>
						<span class="s" v-if="stockList.last.close > stockList.last.open"></span>
						<span class="j" v-if="stockList.last.close < stockList.last.open"></span>
					</div>
					<div class="li_box">
						<div class="li li_green" v-for="item in bids">
							<div class="ts">
								{{ item[0] }}
							</div>
							<div class="ts">
								<span>{{ item[1] }}</span>
							</div>
							<div class="jindu2" :style="{'width':item[3]?item[3]+'%':0+'%'}"></div>
						</div>
					</div>
				</div>
			</div> -->

		</div>
		<van-dialog v-model="show_tz" show-cancel-button @confirm="confirm" @cancel="cancel"
			:confirmButtonText="$t('utils.confirm')" :cancelButtonText="$t('utils.cancel')">
			<div class="items_3">
				<div class="item">
					<div class="item_imgs">
						<img :src="data.img" alt="" />
					</div>
					<div class="item_div1">
						{{ data.title }}
					</div>
					<div class="item_text">
						{{ data["desc_" + lang] }}
					</div>
					<div class="item_div2 item_div2s" style="padding: 0 15px;" v-if="Object.keys(data).length > 0">
						<div class="item_rate flex_col divs">
							<img class="logos" src="@/assets/images/mll.png" alt="">
							<div style="flex-direction: column;">
								<p style="white-space: nowrap;"><span>{{ data.rate }}%</span></p>
								<p style="font-size: 12px;word-break: break-all;width: 100%;display: block;  white-space: pre-wrap;">{{ $t("rgll") }}</p>
							</div>
						</div>
						<div class="item_day flex_col divs">
							<img class="logos" src="@/assets/images/time.png" alt="">
							<div style="flex-direction: column;">
								<p><span>{{ data.day_date_num_text }}</span></p>
								<p style="font-size: 12px;word-break: break-all;width: 100%;display: block;  white-space: pre-wrap;">{{ $t("结算时窗") }}</p>
							</div>
						</div>
						<div class="item_min flex_col divs">
							<img class="logos" src="@/assets/images/qd2.png" alt="">
							<div style="flex-direction: column;">
								<p><span><span style="font-size:15px;">{{ data.project_type ===
									1 ? '$' : $t("utils.moneyMark") }}</span>{{
												data.min
										}}</span></p>
								<p style="font-size: 12px;word-break: break-all;width: 100%;display: block;  white-space: pre-wrap;">{{ $t("utils.startingAmount") }}</p>
							</div>
						</div>
					</div>
					<div class="ps_box">
						<div class="ps">
							<div>
								<span class="t_bian"></span><span>{{ $t('fxbl') }}</span>
							</div>
							<div class="m-right">
								{{ data.breach_penalty_rate }}%
							</div>
						</div>
						<div class="ps">
							<div>
								<span class="t_bian"></span><span>{{ $t('认购方式') }}</span>
							</div>
							<div class="m-right">
								{{ data.day_text }}
							</div>
						</div>
						<div class="ps">
							<div>
								<span class="t_bian"></span><span>{{ $t('结算模式') }}</span>
							</div>
							<div class="m-right">
								{{ data.mode === 1?$t('hbfx'):$t('xxhb') }}
							</div>
						</div>
					</div>
					
					<div class="input_btn">
						<van-field v-model="number" type="number" :placeholder="$t('qsrrgje')" />
					</div>
					<!-- <div class="divs2">
						<p class="m-flex p1 m-pd1-x" v-if="data.project_type === 1">
							<span>{{ $t('票房预估') }}</span>
							<span class="m-right">
								{{ data.project_type === 1 ? '$' : $t("utils.moneyMark") }}{{ data.estimated_revenue }}
							</span>
						</p>
						<p class="bian"></p>
						<p class="m-flex p1 m-pd1-x">
							<span>{{ $t('rgll') }}</span>
							<span class="m-right">
								{{ data.rate }}%
							</span>
						</p>
					</div> -->
					<div class="divs3">
						<input type="checkbox" v-model="isRG">
						<span @click.stoop="isRG = !isRG">{{ $t('zdrg') }}</span>
					</div>
					<!-- <p class="m-flex p1 m-pd1-x">
						{{ $t('shouyi_yj') }}
						<span class="m-right">{{
						(data.fixed_investment_amount * 1 + data.fixed_investment_amount * (data.rate / 100)).toFixed(2) }}</span>
					</p> -->
				</div>
			</div>

		</van-dialog>

		<div class="popup_content" v-if="isSig === 1 && showHt">
			<div class="red_top_bg">
				<div class="back_left" @click="showHt = false"></div>
				<div class="big_tit">{{ $t("home.contract") }}</div>
			</div>
			<template v-if="isSig === 1">
				<div class="tc_wrap" @click.stop @scroll="handleScroll">
					<div class="tc" ref="capture" id="originHtml" style="position: relative">
						<p style="height:20px;"></p>
						<!-- <p class="title title_h">{{ $t("capture_tit") }}</p> -->
						<p class="padding-tb title_h2">
							{{ $t("capture_tit") }}
						</p>
						<p class="padding-tb title_h2" style="position: relative;">
							{{ $t("capture_tit2") }}
							<img style="position: absolute;top:40%;transform: translateY(-50%);left:135px;"
								:src="resultImg" class="esign-img"></img>
						</p>
						<p>{{ $t('capture_info') }}</p>
						<p>{{ $t('capture_info1') }}</p>
						<p>{{ $t('capture_info2', { 'titleName': data.title }) }}</p>
						<p>{{ $t('capture_info3') }}</p>
						<p>
							<b>{{ $t('capture_info4') }}</b>
						</p>
						<p>{{ $t('capture_info5') }}</p>
						<p>{{ $t('capture_info6') }}</p>
						<p>{{ $t('capture_info7') }}</p>
						<p>
							<b>{{ $t('capture_info8') }}</b>
						</p>
						<p>{{ $t('capture_info9') }}</p>
						<p>{{ $t('capture_info10') }}</p>
						<p>{{ $t('capture_info11') }}</p>
						<p>{{ $t('capture_info12') }}</p>
						<p>{{ $t('capture_info13') }}</p>
						<p>{{ $t('capture_info14') }}</p>
						<p>
							<b>{{ $t('capture_info15') }}</b>
						</p>
						<p>{{ $t('capture_info16') }}</p>
						<p>{{ $t('capture_info17') }}</p>
						<p>{{ $t('capture_info18') }}</p>
						<p>
							<b>{{ $t('capture_info19') }}</b>
						</p>
						<p>{{ $t('capture_info20') }}</p>
						<p>{{ $t('capture_info21') }}</p>
						<p>
							<b>{{ $t('capture_info22') }}</b>
						</p>
						<p>{{ $t('capture_info23') }}</p>
						<p>
							<b>{{ $t('capture_info24') }}</b>
						</p>
						<p>{{ $t('capture_info25') }}</p>
						<p>{{ $t('capture_info26') }}</p>
						<p>
							<b>{{ $t('capture_info27') }}</b>
						</p>
						<p>{{ $t('capture_info28') }}</p>
						<p>{{ $t('capture_info29') }}</p>
						<p>
							<b>{{ $t('capture_info30') }}</b>
						</p>
						<p>{{ $t('capture_info31') }}</p>

						<p style="height:26px"></p>

						<p class="b" style="position: relative;height: 40px;">
							<span style="position: absolute;z-index: 1;top: 50%;transform: translateY(-50%);">{{ $t('capture_info32') }}</span>
							<img class="esign-img2" src="@/assets/images/seal.png" />
						</p>
						<p style="height:20px"></p>
						<p class="b" style="position:relative">
							{{ $t('capture_info33') }} <span
								style="display:inline-block;width:100px;border-bottom: 1px solid #333;padding:0 10px;position:absolute;bottom:0px;left:105px;"></span>
							<img style="position: absolute;top:-30%;transform: translateY(-50%);left:115px;"
								:src="resultImg" class="esign-img"></img>
						</p>
						<p class="b">
							{{ $t('capture_info34') }}<span style="border-bottom: 1px solid #333;padding:0 10px;">{{
								year }}.{{ month }}.{{ day }}</span>
						</p>
						<p class="b"></p>
						
						<p style="height: 105px"></p>
					</div>
				</div>
				<van-popup v-model:show="visible" class="esign-container" :close-on-click-overlay="false"
					get-container="#app">
					<vue-esign class="sign-view" ref="esign" :width="800" :height="500" :isCrop="isCrop"
						:lineWidth="lineWidth" :lineColor="lineColor" bgColor.sync="" />
					<div class="btn-list">
						<div class="btn-left">
							<button class="warning" @click="reset">{{ $t("重置") }}</button>
							<button class="warning" @click="goback">{{ $t("返回上一步") }}</button>
						</div>
						<button class="primary" @click="save">{{ $t("confirm") }}</button>
					</div>
				</van-popup>
				<div style="height: 10px"></div>
				<div class="pop-bnt">
					<div @click="agreement" style="pointer-events: auto">
						<button type="primary" color="var(--color-main)" class="button"
							:class="{ 'disabled-btn': scrollDisbled }" :readonly="scrollDisbled">
							{{ $t("同意并签名") }}
						</button>
					</div>
					<button type="primary" color="var(--color-main)" class="button"
						:class="{ 'disabled-btn': scrollDisbled }" :disabled="scrollDisbled" @click="argeementEsign">
						{{ $t("confirm") }}
					</button>
				</div>
				<div style="height: 10px"></div>
			</template>
		</div>
	</div>

</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from 'vue';
import Api from "../../interface/index";
import vueEsign from "vue-esign";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import axios from 'axios'
import { Progress, Dialog, Field, Toast } from 'vant';
Vue.use(Progress).use(Dialog).use(Field);
let dates = new Date()
export default {
	name: "itemDetail",
	components: {
		vueEsign,
	},
	data() {
		return {
			data: {},
			show_tz: false,
			number: "",
			isSig: 1,
			lang: localStorage.getItem('lang'),
			stockList: {},
			bids: [],
			asks: [],
			timeOut: null,
			isRG: true,
			receivedParams: null,
			showHt: false,

			esign: null,
			resultImg: null,
			lineWidth: 6,
			lineColor: "#000000",
			isCrop: false,
			scrollDisbled: true,
			visible: false,
			sign_img: '',
			titleName: '',
			id: '',
			year: dates.getFullYear(),
			month: dates.getMonth() + 1,
			day: dates.getDate(),
		};
	},
	created() {
		this.$parent.footer('item', false);
	
		// Fetch("/user/info").then((r) => {
		// 	if (r.data.is_sign) {
		// 		this.isSig = 2;
		// 		return;
		// 	}
		// 	this.isSig = 1;
		// });
	},
	mounted() {
		this.start();
	},
	beforeDestroy() {
		if (this.timeOut) {
			clearInterval(this.timeOut); // 清除定时器，防止内存泄漏
			this.timeOut = null; // 将引用设置为null，帮助垃圾回收
		}
	},
	methods: {
		agreement() {
			if (this.scrollDisbled) {
				this.$toast(this.$t("ydht"));
			} else {
				this.visible = true;
			}
			// this.show=false;
			// this.checked=true;
		},
		argeementEsign() {
			if (this.resultImg) {
				this.getImg();
			} else {
				this.$toast(this.$t("请签字后再提交"));
			}
		},
		reset() {
			this.$refs.esign.reset();
			this.resultImg = null;
		},
		save() {
			this.$toast.loading({
				message: this.$t("upLoading"),
				forbidClick: true,
				duration: 0
			});
			// 可选配置参数 ，在未设置format或quality属性时可在生成图片时配置 例如： {format:'image/jpeg', quality: 0.5}
			this.$refs.esign.generate({ format: "image/jpeg", quality: 0.5 });
			this.$refs.esign.generate()
				.then((res) => {
					// console.log("res ->", res);
					this.resultImg = res;
					this.visible = false;
					this.$toast.clear()
				})
				.catch((err) => {
					// 画布没有签字时会执行这里 'Not Signned'
					// this.$message.error("您还未完成签字，请签字完成后保存");
					this.$toast(this.$t("请签字后再提交"));
				});
		},
		convertBase64ToFile(urlData, filename) {
			var arr = urlData.split("base64,");
			var type = arr[0].match(/:(.*?);/)[1];
			var fileExt = type.split("/")[1];
			var bstr = atob(arr[1]);
			var n = bstr.length;
			var u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename + "." + fileExt, {
				type: type,
			});
		},
		handleScroll(e) {
			const { scrollTop, clientHeight, scrollHeight } = e.target;
			console.log(scrollTop, clientHeight, scrollHeight);
			if (scrollTop + clientHeight + 2 >= scrollHeight) {
				// alert('滚动到底部啦')
				this.scrollDisbled = false;
				console.log(this.scrollDisbled);
			}
		},
		goback() {
			this.$refs.esign.reset();
			this.resultImg = null;
			this.visible = false;
		},
		getImg() {
			let that = this;
			this.$toast(this.$t("loading"))
			this.$refs.capture.scrollTop = 0;
			this.$refs.capture.style.fontSize = "24px";
			if (window.top) {
				this.$refs.capture.style.width = "1220px";
				this.$refs.capture.style.paddingRight = '20px';
			}
			html2Canvas(this.$refs.capture, {
				allowTaint: true,
				useCORS: true,
				scale: 1,
			}).then((canvas) => {
				// console.log(canvas, "canvas");
				//内容的宽度
				let contentWidth = canvas.width;
				//内容高度
				let contentHeight = canvas.height;
				//一页pdf显示html页面生成的canvas高度,a4纸的尺寸[595.28,841.89];
				let pageHeight = (contentWidth / 592.28) * 841.89;
				//未生成pdf的html页面高度
				let leftHeight = contentHeight;
				//页面偏移
				let position = 0;
				//a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
				let imgWidth = 595.28;
				let imgHeight = (592.28 / contentWidth) * contentHeight;
				//canvas转图片数据
				let pageData = canvas.toDataURL("image/jpeg", 1);
				//新建JsPDF对象
				let PDF = new JsPDF("", "pt", "a4");
				//判断是否分页

				if (leftHeight < pageHeight) {
					PDF.addImage(pageData, "JPEG", 10, 1, imgWidth, imgHeight);
				} else {
					while (leftHeight > 0) {
						PDF.addImage(pageData, "JPEG", 10, position, imgWidth, imgHeight);
						leftHeight -= pageHeight;
						position -= 841.89;
						if (leftHeight > 0) {
							PDF.addPage();
						}
					}
				}
				let blob = this.convertBase64ToFile(PDF.output("dataurlstring"), "esign.pdf");
				// PDF.save('esign.pdf')
				let fileOfBlob = new File([blob], "esign.pdf");
				let formData = new FormData(); //通过formdata上传
				// console.log("fileOfBlob ->", fileOfBlob);
				formData.append("file", fileOfBlob);
				formData.append("moduleName", "seller");
				formData.append("type", "file");
				formData.append('language', this.$i18n.locale || "en_us");
				formData.append('token', localStorage.getItem('token'));
				this.$refs.capture.style.fontSize = "14px";
				if (window.top) {
					this.$refs.capture.style.width = "100%";
				}
				axios.post(Api.commonUrl + "/api/index/upload_sign_img", formData).then(resd => {
					console.log(resd,'resdresdresdresdresdresd')
					if(resd.data.code === 0){
						Toast(resd.data.info)
						return
					}
					that.sign_img = resd.data.data
					that.showHt = false
					this.isSig = 2
					this.show_tz = true
				});
			});
		},
		qrConfirm(e) {
			console.log(e, 'eee')
		},
		investFun(type) {
			let arr = this.data.invest_term
			let item = arr.find(x => x.value == type)
			let a = item.name_text ? item.name_text : ''
			return this.$t(a)
		},
		init() {
			Fetch("/stock/item", { id: this.$router.history.current.params.code }, 'post', false).then((r) => {
				this.stockList = r.data.stock
				let buyIn = r.data.stock.bids
				let out = r.data.stock.asks

				let buyOutTotal = 0
				let sellOutTotal = 0

				for (let i = 0; i < buyIn.length; i++) {
					buyOutTotal += buyIn[i][1]
				}
				for (let i = 0; i < out.length; i++) {
					sellOutTotal += out[i][1]
				}
				for (let i = 0; i < buyIn.length; i++) {
					buyIn[i][3] = buyIn[i][1] / buyOutTotal * 100 + 8
				}
				for (let i = 0; i < out.length; i++) {
					out[i][3] = out[i][1] / sellOutTotal * 100 + 8
				}
				this.asks = out
				this.bids = buyIn
			});
		},
		start() {
			Fetch('/index/item_detail', {
				id: this.$router.history.current.params.code
			}).then(res => {
				this.data = res.data;
				if (this.data.sign_img_status == 1) {
					this.isSig = 2;
				} else {
					this.isSig = 1;
				}

				// if(res.data.project_type == 1) {
				// 	this.init()
				// 	this.timeOut = setInterval(() => {
				// 		this.init()
				// 	},5000)
				// }
			})
		},
		buy(item) {
			if (this.isSig === 1) {
				this.showHt = true
				// this.$router.push("/contracts/" + this.data.id + '/' + this.isSig + '/' + this.data.title);
				return;
			}
			this.show_tz = true;
		},
		cancel() {
			this.number = ''
		},
		formatNumbers(value) {
			value = value.split(',').join('')
			console.log(value, 'value')
			if (value >= 100000000) {
				return (value / 100000000).toFixed(1).replace(/\.0$/, '') + this.$t('亿');
			} else if (value >= 10000) {
				return (value / 10000).toFixed(1).replace(/\.0$/, '') + this.$t('万');
			} else {
				return value.toString();
			}
		},
		confirm(e) {
			console.log(e,'eee')
			// console.log(this.isRG,'this.isRG')
			if (!this.isRG) {
				this.$toast(this.$t('qgxdrg'));
				return
			}
			let lang = localStorage.getItem("lang")
			if (!lang) {
				lang = "id_id"
			}
			if (!this.number) {
				this.$toast(this.$t('qsrrgje'));
				return false;
			}
			let data = {
				id: this.data.id,
				money: this.number,
				day: this.data.day
				// money:this.data.project_type === 1?this.number:this.data.fixed_investment_amount
			}
			if (this.sign_img != '') {
				data.sign_img = this.sign_img
			}
			Fetch("/index/item_apply", data).then(r => {
				if (r.code == 1) {
					Toast(r.info ? r.info : r.msg)
					setTimeout(() => {
						this.$router.push("/order");
					}, 1500);
				} else {
					Toast(r.msg)
				}
			}).catch(err => {
				this.number = '';
			})
		}
	}
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
	padding: 15px 26px;
}

.red_top_bg {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10;
	display: flex;
	align-items: center;
}

.back_left {
	margin: 0px 0px 0px 10px;
	background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
	left: 40px;
	width: 90%;
	color: #000000;
	transform: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 16px;
}

.item_img {
	margin: 35px auto 0 auto;
	width: 100%;

	img {
		width: 100%;
		border-radius:10px 10px 0px 0px ;
	}
}

.items_3 {
	margin: 0px auto;
	width: 100%;

	.item {
		background: #FFFFFF;

		.item_div1 {
			display: flex;
			justify-content: center;
			padding: 12px 5px;
			font-size: 15px;
			font-weight: bold;
		}

		.item_div2 {
			width: 100%;
			margin: 10px auto;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			font-size: 14px;
			.divs {
				width: 32%;
				background: #FAFAFA;
				border-radius: 10px;
				display: flex;
				flex-direction: column;
				padding:5px 4px;
				justify-content: center;
				align-items: center;
			}
			div {
				width: 100%;
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				white-space: nowrap;
				.logos {
					width: 22px;
					height: 22px;
					margin-right: 2px;
				}

				p {
					padding: 0px;
					text-align: left;
					color: #A399AE;
					text-align: center;
					font-size: 13px;

					span {
						font-size: 18px;
						font-weight: bold;
						color: #000;
					}
				}

				.mt2 {
					margin-top: 5px;
				}
			}

			.bians {
				width: 1px;
				padding: 0px;
				height: 40px;
				background: #333;
			}

			.item_rate {

				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;
				}
			}

			.item_day {

				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;
				}
			}

			.item_min {

				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;
				}
			}
		}
		.item_div2s {
			margin: 0px auto;
			.divs {
				box-shadow: 0px 2px 2px #EBEBEB;
				p span {
					font-size: 15px;
				}
			}
		}
		.ps_box {
			width: 92%;
			border-radius: 10px;
			margin: 15px auto;
			border: 1px solid #EBEBEB;
			background: #FAFAFA;
			.ps {
				width: 100%;
				height: 42px;
				padding: 0 15px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #EBEBEB;
				.t_bian {
					display: block;
					width: 3px;
					background: #198DFF;
					height: 14px;
					margin-right: 10px;
				}
				div,span {
					font-size: 14px;
					color: #666;
					display: flex;
					align-items: center;
				}
				.m-right {
					width: 50%;
					color: #333;
					font-weight: bold;
					display: flex;
					justify-content: flex-end;
					align-items: center;
				}
			}
			.ps:last-child {
				border-bottom: none;
			}
		}
		.input_btn {
			width: 92%;
			height: 42px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			margin: 0 auto;
			border: 1px solid #EBEBEB;
		}
		.item_div3 {
			color: #999;
			padding: 5px 10px;
			display: flex;
			flex-direction: column;
			align-items: self-start;

			span {
				font-size: 14px;
			}
		}

		.item_div4 {
			width: 100%;
			padding: 0px 10px 20px 10px;
			margin-top: 10px;
			.flexs {
				width: 100%;
				display: flex;
				justify-content: space-between;
				padding-bottom: 5px;
				color: #7F7E7E;
				font-size: 12px;
			}
			div:nth-child(1) {
				width: 100%;
				margin-top: 0px;
			}
		}

		.item_btn {
			width: 70%;
			position: absolute;
			display: flex;
			justify-content: space-around;
			bottom: 20px;
			left: 50%;
			max-width: 500px;
			transform: translateX(-50%);
			z-index: 100;

			button {
				width: 100%;
				color: #000;
				padding: 10px 5px;
				border-radius: 5px;
				border: 1px solid #000;
				background: #EBF302;
			}

			.red {
				background: #ab2001;
				color: #fff;
			}

			.green {
				background: #078600;
				color: #fff;
			}

			.item_btn_over {
				color: #999;
				border: 1px solid #999;
			}
		}
	}

	.item_content {
		background: #FFFFFF;
		padding: 10px;
		line-height: 20px;
		padding-bottom: 10px;
		word-wrap: break-word;
		white-space: normal;
	}
}

.item_imgs {
	width: 100%;
	height: fit-content;
	padding: 5px 5px 0px 5px;

	img {
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 10px 10px 0px 0px;
		object-fit: contain;
	}
}

.item_text {
	font-size: 14px;
	color: #333;
	padding: 0 10px;
	word-break: break-all;
}

/deep/ td {
	border: 1px solid #999 !important;
	padding: 2px 4px;
	word-wrap: break-word !important;
	white-space: normal !important;
}

.flex_col {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.divs {
	display: flex;
	align-items: center;
	width: 100%;
	height: fit-content;
	.my_1 {
		margin: 4px auto 0px auto;
	}
	span {
		display: block;
		display: flex;
		align-items: center;
		font-size: 15px;
		justify-content: center;
		padding:  0px;
		font-weight: bold;
	}
}

.divs2 {
	width: 100%;
	display: flex;
	align-items: center;
	height: fit-content;
	border-bottom: 1px solid #000;
	border-top: 1px solid #000;
	margin: 0px !important;
	font-weight: bold;

	.bian {
		height: 40px;
		width: 1px;
		background: #000;
		padding: 0px;
	}

	p {
		width: 50%;
		height: 40px;
		padding: 10px 0px;

		span {
			width: 50%;
			display: flex;
			height: 40px;
			justify-content: center;
			align-items: center;
			border-right: 1px solid #000;
			font-size: 13px;
			font-weight: bold;
			padding: 0 3.5px;
			word-wrap: break-word;
			overflow-wrap: break-word;
			word-break: break-all;
		}

		span:last-child {
			border-right: none;
			color: #888;
		}
	}
}

.divs3 {
	width: 92%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 15px 0px;
	span {
		font-size: 12px;
		margin-left: 5px;
	}
}

::v-deep .van-cell {
	padding: 5px 20px;
}

::v-deep .van-field__control {
	text-align: center;
}

.van-dialog {
	width: 94%;
	top: 50%;
	max-width: 700px;
}



.popup_content {
	width: 100%;
	height: 100dvh;
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 999;
	background: #fff;
	padding: 44px 0 0px 0px !important;
	max-width: 750px;

	.tc_wrap {
		width: 98%;
		height: calc(100dvh - 150px);
		position: relative;
		padding: 10px 5px 10px 10px;
		margin: 0 auto;
		overflow-y: scroll;
		background: #eee;
		border-radius: 10px;
	}

	.close-btn {
		width: 24px;
		height: 24px;
		top: 10px;
		right: 10px;
	}
}

.popup_content .title_h {
	font-weight: 600;
	font-size: 21px;
	line-height: 26px;
	text-align: center;
}

.popup_content .title_h2 {
	font-weight: bold;
	font-size: 18px;
	display: flex;
	align-items: center;
	margin: 20px auto;
}

.popup_content p {
	color: "#333" !important;
	font-size: 15px;
	line-height: 18px;
	margin: 10px auto;
	padding-right: 10px;
	word-break: break-all;
}

.red {
	color: #ee0a24;
}

.disabled-btn {
	background: #859ac8 !important;
}

.esign-content {
	width: 100%;
}

.heights {
	height: 90%;
}

.esign-img {
	width: 80px;
	margin-left: 0px;
	margin-top: 3px;
}

.esign-img4 {
	width: 80px;
	margin-left: 30px;
}

.esign-img2 {
	width: 2.75rem;
	height: auto;
	position: absolute;
	left: 135px;
	bottom: -30px;
	z-index: 0;
}

.b {
	width: 100%;
	font-weight: bold;
	margin: 20px 0px 0px 0px;
}

.esign-img3 {
	height: 20px;
}
.van-popup--center {
	width: 300px;
}
.b {
	width: 100%;
	font-size: 15px;
	font-weight: bold;
	margin: 10px 0px;
}

.pop-bnt {
	width: 100% !important;

	.button {
		background: #0e3893;
		color: #fff;
		padding: 8px 20px;
		border-radius: 6px;
		margin: 0 !important;
		margin-top: 10px !important;
		border: #333 !important;

		&:nth-child(1) {
			margin-right: 20px !important;
			margin-bottom: 10px;
		}
	}
}

.pop-bnt {
	width: 28%;
	margin: 0 auto 10px;
	display: flex;
	justify-content: center;

	.van-button {
		margin: 0 !important;

		&:nth-child(1) {
			margin-right: 20px !important;
			margin-bottom: 10px !important;
		}
	}
}

.btn-list {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 10px;
	border-top: 1px solid #eee;

	.btn-left {
		display: flex;
		justify-content: center;
	}

	button {
		width: fit-content;
		height: 40px;
		margin: 5px 10px !important;
		padding: 0px 15px;
		color: #fff;
		border-radius: 6px;
		white-space: nowrap;
	}

	.warning {
		background: #f3253d;
	}

	.primary {
		background: #0e3893;
	}
}
::v-deep .van-progress__pivot {
  display: none;
}
::v-deep .van-dialog__cancel {
	margin: 10px 5px 10px 5px;
	border: 1px solid #DCDCDC;
	border-radius: 10px;
	touch-action: manipulation;
}
::v-deep .van-dialog__confirm {
	margin: 10px 5px 10px 5px;
	border: 1px solid #DCDCDC;
	background: #1890FF;
	color: #fff;
	border-radius: 10px;
	touch-action: manipulation;
}
::v-deep .van-dialog__confirm .van-button__text {
	color: #fff;
}
.esign-container {
	margin: 0px !important;
}
</style>
